import Vue from "vue";
import axios from "axios";

Vue.use({
  install(Vue) {
    const axiosCustom = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        token: localStorage.getItem("token")
      }
    });

    axiosCustom.interceptors.request.use(config => {
      NProgress.start();
      return config;
    });

    axiosCustom.interceptors.response.use(
      response => {
        NProgress.done();
        return response;
      },
      error => {
        NProgress.done();

        if (error.response && error.response.status === 401) {
          const currentPath = window.location.pathname + window.location.search;
          localStorage.removeItem("token");
          window.location.href = `/login?returnUrl=${encodeURIComponent(
            currentPath
          )}`;
        }

        return Promise.reject(error);
      }
    );

    axiosCustom.interceptors.request.use(
      config => {
        // Atualiza o token dinamicamente do localStorage
        const token = localStorage.getItem("token");
        if (token) {
          config.headers["token"] = token;
        }
        config.headers["company"] = sessionStorage.getItem("company");
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    Vue.prototype.$clubApi = axiosCustom;
  }
});
